import { render, staticRenderFns } from "./baseChoose.vue?vue&type=template&id=dac5d66e&scoped=true&"
import script from "./baseChoose.vue?vue&type=script&lang=js&"
export * from "./baseChoose.vue?vue&type=script&lang=js&"
import style0 from "./baseChoose.vue?vue&type=style&index=0&id=dac5d66e&prod&lang=scss&"
import style1 from "./baseChoose.vue?vue&type=style&index=1&id=dac5d66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac5d66e",
  null
  
)

export default component.exports